import type { AuthTokenPayload } from '@/tools/auth'

export const getAuthPayload = (payload: AuthTokenPayload) => {
  const { facebookId, grantType, token, identityFlowId, username, password } = payload

  switch (grantType) {
    case 'google':
      return {
        grantType,
        googleToken: token,
      }
    case 'googleBearer':
      return {
        grantType: 'google',
        googleBearerToken: token,
      }
    case 'facebook':
      return {
        grantType,
        facebookToken: token,
        facebookId,
      }
    case 'phone':
      return {
        grantType,
        identityFlowId,
      }
    default: {
      return {
        grantType: 'password',
        username: username,
        password: password,
      }
    }
  }
}
